import { Expose } from "class-transformer";

export class AddressModel {
  @Expose({ name: "address" })
  address?: string;

  @Expose({ name: "provinceName" })
  provinceName?: string;

  @Expose({ name: "subdistrictName" })
  subdistrictName?: string;

  @Expose({ name: "districtName" })
  districtName?: string;

  @Expose({ name: "zipCode" })
  zipCode?: string;
}